import { render } from "./BibleView.vue?vue&type=template&id=869466d4&scoped=true"
import script from "./BibleView.vue?vue&type=script&lang=js"
export * from "./BibleView.vue?vue&type=script&lang=js"

import "./BibleView.vue?vue&type=style&index=0&id=869466d4&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Vue\\www\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-869466d4"]])

export default __exports__